import type {
  ListResponsePriceOverrideApprovals,
  PriceOverrideApproveRejectInput,
} from "@classes-service-types/index";
import { type UseMutationOptions, useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";

type UsePriceOverridesRejectArgs = {
  payload: PriceOverrideApproveRejectInput;
};

export const usePriceOverridesReject = (
  useMutationOptions?: UseMutationOptions<ListResponsePriceOverrideApprovals, Error, UsePriceOverridesRejectArgs>,
) => {
  // const queryClient = useQueryClient();

  return useMutation<ListResponsePriceOverrideApprovals, Error, UsePriceOverridesRejectArgs>({
    mutationFn: async (priceOverrideRejectArgs) => {
      const response: AxiosResponse<ListResponsePriceOverrideApprovals> = await learningServiceRequest({
        method: "put",
        url: "/price_overrides/reject/",
        payload: priceOverrideRejectArgs.payload,
      });
      return response.data;
    },
    ...useMutationOptions,
  });
};
